<template>
  <div class="dialog">
    <img src="/status_images/page_not_found.svg" alt="404 error" />
    <h1 class="error-header">
      <template v-if="isTidra"> 404: Page Not Found. </template>
      <template v-else>
        404: You’ve found <i><b>Oops</b></i
        >Level.
      </template>
    </h1>
    <p class="error-message">
      Sorry, we couldn’t find the page you were looking for, and this isn’t a
      place you want to be.
    </p>
    <p>Let’s get you back to a better place...</p>
    <a :href="isTidra ? '/initiatives' : '/dashboard'">
      Go to my {{ isTidra ? "Initiatives" : "Dashboard" }}
    </a>
  </div>
</template>

<script>
export default {
  name: "NotFoundError",
  inject: ["isTidra"],
};
</script>

<style scoped>
.error-message {
  margin-bottom: 4px;
}

.error-header {
  font-size: 32px;
  font-weight: 400;
}

.dialog {
  background-color: white;
  margin: 20px;
  padding: 60px;
  display: flex;
  flex-direction: column;
  align-items: center;
}
</style>
